import { Injectable } from '@angular/core';
import { ErrorPipeline } from './error-pipeline';
import { ErrorPacket, Pipe } from './types';
import { createErrorTerminal } from './error-terminal';
import { ErrorConverterService } from '../services/error-converter.service';
import { ErrorTrustedService } from '../services/error-trusted.service';
import { EmailNotValidatedPipe } from './pipes/email-not-validated.pipe';
import { HttpJsonApiErrorPipe } from './pipes/http-jsonapi-error.pipe';
import { JsonApiErrorPipe } from './pipes/jsonapi-error.pipe';
import { PromiseRejectionPipe } from './pipes/promise-rejection.pipe';
import { HttpErrorResponsePipe } from './pipes/http-error-response.pipe';
import { BaseExceptionPipe } from './pipes/base-exception.pipe';
import { TrustedErrorPipe } from './pipes/trusted-error.pipe';
import { RuntimeErrorPipe } from './pipes/runtime-error.pipe';

@Injectable()
export class ErrorPipelineFactory {
    public constructor(
        private readonly errorConverter: ErrorConverterService,
        private readonly errorTrustedService: ErrorTrustedService,
    ) {}

    public create(): ErrorPipeline<ErrorPacket, ErrorPacket> {
        const pipes: Array<Pipe<ErrorPacket, ErrorPacket>> = [
            new EmailNotValidatedPipe(this.errorConverter),
            new HttpJsonApiErrorPipe(this.errorConverter),
            new JsonApiErrorPipe(this.errorConverter),
            new PromiseRejectionPipe(this.errorConverter),
            new HttpErrorResponsePipe(this.errorConverter),
            new BaseExceptionPipe(),
            new TrustedErrorPipe(this.errorConverter, this.errorTrustedService),
            new RuntimeErrorPipe(this.errorConverter),
        ];

        return new ErrorPipeline(pipes, createErrorTerminal(this.errorConverter));
    }
}
